var map = {
	"./Ambulance.png": 1377,
	"./Ask A Doctor.png": 1378,
	"./Blood Cells.png": 1379,
	"./Brain.png": 1380,
	"./Dental.png": 1381,
	"./Depression.png": 1382,
	"./Diagnostics.png": 1383,
	"./Disabled.png": 1384,
	"./Doctor.png": 881,
	"./Ear.png": 1385,
	"./Hospital.png": 1386,
	"./Injection.png": 1387,
	"./Medical Book.png": 1388,
	"./Medical Folder.png": 1389,
	"./Mouth.png": 1390,
	"./Online Claim.png": 1391,
	"./Online Pharmacy.png": 1392,
	"./Optometry.png": 1393,
	"./Pill Bottle.png": 1394,
	"./Podiatry.png": 1395,
	"./Price Tag.png": 1396,
	"./Radiation Theraphy.png": 1397,
	"./Savings.png": 1398,
	"./Symptom List.png": 1399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1376;